import React, { useState, useContext } from "react";
import classes from "./Actions.module.css";

import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DoNotDisturbOnRoundedIcon from "@mui/icons-material/DoNotDisturbOnRounded";
import ActionModal from "./ActionModal";
import {
  extractDomain,
  sortRecommendedActionsData,
} from "../../../../utils/helpers";
import { OVERVIEW_LLM_LABELS } from "../../../../utils/constant";
import { AuthContext } from "../../../../context/auth-context";
import { getNonActionableMetricData } from "../../../../services/apiService";
import NonActionModal from "./NonActionDataModal";

export const ActionTable = ({
  actionMetricsData,
  handleChange,
  sourceAliasIds,
  domaUrlsMapping,
  isBrandAudit = false,
  id="FocusArea"
}) => {
  const [open, setOpen] = useState(false);
  const [isopen, setIsOpen] = useState(false);
  const [modalData, setModalData] = useState();
  const [actionType, setActionType] = useState();
  const [isDataLoading, setIsDataLoading] = useState(false)
  const [nonActionsData, setNonActionsData] = useState([])
  const { user } = useContext(AuthContext);
  const customerId = user?.customer_id || 0;
  const isCompanyUser = user?.user_role?.role?.name === "Company user"


  const handleClose = () => setOpen(false);

  const handleNonActionModalClose = () => {
    setModalData([])
    setNonActionsData([])
    setIsOpen(false)
    setIsDataLoading(false)
  }

  const handleModalData = (data, type) => {
    setOpen(true);
    setModalData(data);
    setActionType(type);
  };

  const handleGoodScoreData = async (data, type) => {
    const dataLookup = {
      'sentiment': ['sentiment'],
      'reach': ['visibility'],
      'risk': ['product_taxonomy', 'brand_pillars', 'purchase_criteria']
    };

    const {
      brand,
      category,
      persona,
      llm,
      market,
      geography
    } = data;

    const payload = {
      customer_id: customerId,
      brand,
      category,
      persona,
      llm,
      market,
      geography,
      entityType: data?.isProduct ? 'product' : 'brand',
      isCompanyUser
    };

    setIsOpen(true);
    setIsDataLoading(true);

    try {
      const keysToExtract = dataLookup[type] || [];
      let result = {}
      if (!data?.nonActionsObj) {
        result = await getNonActionableMetricData(payload);
      }
      else {
        result = data?.nonActionsObj ?? {}
      }
      const mergedData = keysToExtract.flatMap(key => result[key] || []);
      setNonActionsData(mergedData)


      // update the state
      setModalData(data);
      setIsDataLoading(false);

    } catch (err) {
      setIsDataLoading(false);
      console.error('Error fetching data:', err);
    }
  };

  const headers = [
    "Brand/Product",
    "Category",
    "LLM",
    ...(isBrandAudit ? [] : ["Persona", "Geography"]),
    "Market",
    "Visibility",
    "Sentiment",
    "Performance",
  ];

  if (!actionMetricsData || actionMetricsData.length === 0) {
    return;
  }

  return (
    <div className="col-md-12">
      <ActionModal
        type={actionType}
        data={modalData}
        open={open}
        handleClose={handleClose}
        handleChange={handleChange}
        sourceAliasIds={sourceAliasIds}
      />

      <NonActionModal open={isopen} handleClose={handleNonActionModalClose} isDataLoading={isDataLoading} data={modalData} nonActionsData={nonActionsData} />

      <div className={classes.tableContainer} id={id}>
        <table className="table table-striped">
          <thead
            style={{
              position: "sticky",
              top: 0,
            }}
          >
            <tr style={{ textAlign: "center" }} className="prdtblHeader">
              {headers.map((header, index) => (
                <th
                  style={{ textAlign: index === 0 ? "left" : "center" }}
                  key={header}
                >
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {!!actionMetricsData.length ? (
              sortRecommendedActionsData(actionMetricsData)?.map(
                (data, index) => {
                  const reachCount = data?.Reach && data?.Reach.length;

                  const sentimentCount =
                    data?.Sentiment && data?.Sentiment.length;

                  const riskCount =
                    data?.Performance && data?.Performance.length;

                  return (
                    <tr style={{ textAlign: "center" }} key={index}>
                      <td>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "12px",
                            marginLeft: "8px",
                          }}
                        >
                          <img
                            className={classes.logo}
                            src={`https://img.logo.dev/${extractDomain(
                              domaUrlsMapping?.[data?.brand]
                            )}?token=pk_SaDf4t2eRsW5Fc84zgJRZA`}
                            alt={data?.brand}
                          />
                          <span style={{ textAlign: "left" }}>
                            {data?.brand}
                          </span>
                        </div>
                      </td>
                      <td>{data?.category}</td>
                      <td>{OVERVIEW_LLM_LABELS?.[data?.llm] || data?.llm}</td>
                      {!isBrandAudit && (
                        <>
                          <td>{data?.persona}</td>
                          <td>{data?.geography}</td>
                        </>
                      )}
                      <td>{data?.market}</td>
                      <td
                        onClick={() => {
                          reachCount ? handleModalData(data, "reach") : handleGoodScoreData(data, "reach")
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        {reachCount ? (
                          <CheckCircleIcon
                            style={{
                              color: "#FC4C4E",
                              // "#36CFC2"
                            }}
                          />
                        ) : (
                          <DoNotDisturbOnRoundedIcon
                            style={{ color: "#36CFC2" }}
                          />
                        )}
                      </td>
                      <td
                        onClick={() => {
                          sentimentCount ? handleModalData(data, "sentiment") : handleGoodScoreData(data, "sentiment")
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        {sentimentCount ? (
                          <CheckCircleIcon
                            style={{
                              color: "#FC4C4E",
                              // "#36CFC2"
                            }}
                          />
                        ) : (
                          <DoNotDisturbOnRoundedIcon
                            style={{ color: "#36CFC2" }}
                          />
                        )}
                      </td>
                      <td
                        onClick={() => {
                          riskCount ? handleModalData(data, "risk") : handleGoodScoreData(data, "risk")
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        {riskCount ? (
                          <CheckCircleIcon
                            style={{
                              color: "#FC4C4E",
                              // "#36CFC2"
                            }}
                          />
                        ) : (
                          <DoNotDisturbOnRoundedIcon
                            style={{ color: "#36CFC2" }}
                          />
                        )}
                      </td>
                    </tr>
                  );
                }
              )
            ) : (
              <div style={{ minHeight: "300px" }}></div>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};
